module.exports = __webpack_public_path__ + "static/media/login-prm-pic1-en.368cca45.jpg";